import {ChangeDetectorRef, Component, ElementRef, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractDateInput} from "../abstract-date-input";
import {FUIEventsService} from "../../../../events/events.service";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIEditDateInputComponent),
            multi: true
        }
    ],
    selector: "fui-edit-date-input",
    styleUrls: ["./edit-date-input.component.scss"],
    templateUrl: "./edit-date-input.component.html",
    standalone: false
})
export class FUIEditDateInputComponent extends FUIAbstractDateInput {
    constructor(elementRef: ElementRef,
                changeDetectorRef: ChangeDetectorRef,
                eventsService: FUIEventsService) {
        super(elementRef, changeDetectorRef, eventsService);
    }
}
